import styled from "styled-components";

import { Icon as IconCore } from "@components/icon";

export const Icon = styled(IconCore)`
  path {
    fill: #d46b08;
  }
`;
